import { connect } from "react-redux"
import {
  getEntityTypeMapping,
  getMatchFromRouter,
} from "../../helpers/sharedHelperFunctions"
import { POSSIBLE_CHILD_ENTITIES } from "../../helpers/sharedConstants"
import { graphqlDynamic } from "react-apollo-dynamic-query"
import gql from "graphql-tag"
import SecondaryNav from "."

const generateQuery = ({ parentEntityType, entityType }) => {
  const possibleEntities =
    POSSIBLE_CHILD_ENTITIES[getEntityTypeMapping(entityType).singularField]
  const childQueries = possibleEntities
    .map(field => `${field}(limit: 1) { id }`)
    .join("\n")
  return gql`
    query SecondaryNav($parentEntityId: ID!, $entityId: ID!) {
      parentEntity: ${
        getEntityTypeMapping(parentEntityType).singularField
      }(id: $parentEntityId) {
        id
        entity: ${
          getEntityTypeMapping(entityType).singularField
        }(id: $entityId) {
          id
          ${childQueries}
        }
      }
    }
  `
}

const SecondaryNavtWithApollo = graphqlDynamic(generateQuery, {
  options: ({ parentEntityId, entityId }) => ({
    variables: {
      parentEntityId,
      entityId,
    },
  }),
  props: ({ data: { error, loading, parentEntity }, ownProps }) => {
    if (error) {
      throw error
    }
    if (!loading) {
      if (!parentEntity) {
        throw Error("404")
      }

      const disabledLinks = Object.entries(parentEntity.entity)
        .filter(
          childEntity =>
            POSSIBLE_CHILD_ENTITIES[
              getEntityTypeMapping(ownProps.entityType).singularField
            ].includes(childEntity[0]) && childEntity[1].length === 0
        )
        .map(childEntity => childEntity[0])

      return { disabledLinks }
    }
  },
})(SecondaryNav)

const SecondaryNavWithData = connect(({ router }) => {
  const match = getMatchFromRouter(router)

  return {
    activeTab: match.params.childEntityType || "overview",
    entityType: match.params.entityType,
    ...match.params,
  }
})(SecondaryNavtWithApollo)

export default SecondaryNavWithData
